import { MenuItemModel } from "./menu-item.model";

export class MenuItemDto {
  isCurrentPage: boolean = false;
  isVisible: boolean = false;
  menuItem: MenuItemModel;
}

